export const DROPDOWN_POSITION_LEFT = 'left';
export const DROPDOWN_POSITION_RIGHT = 'right';
export const DROPDOWN_POSITION = {
	LEFT: DROPDOWN_POSITION_LEFT,
	RIGHT: DROPDOWN_POSITION_RIGHT
};